import React from "react";
import { Box } from "../../design-system";
import { colors } from "../../design-system/colors";
import { PROFILE_TAB } from "../constants/accountText";

const VALUE_COLOR = colors.neutral.white;
const EDIT_BUTTON_COLOR = colors.neutral.white;

interface ProfileCardHeaderProps {
  onEditClick: () => void;
}

const ProfileCardHeader = ({ onEditClick }: ProfileCardHeaderProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <Box
      component="span"
      sx={{
        fontFamily: "Outfit, sans-serif",
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: "34px",
        color: VALUE_COLOR,
      }}
    >
      {PROFILE_TAB.SECTION_TITLE}
    </Box>

    <Box
      component="button"
      onClick={onEditClick}
      sx={{
        fontFamily: "Mulish, sans-serif",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "14px",
        color: EDIT_BUTTON_COLOR,
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: "11px 8px",
        borderRadius: "13px",
        "&:hover": { opacity: 0.8 },
        "&:focus-visible": {
          outline: `2px solid ${colors.primary[500]}`,
          outlineOffset: "2px",
        },
      }}
    >
      {PROFILE_TAB.EDIT_BUTTON}
    </Box>
  </Box>
);

export default ProfileCardHeader;
